export default __webpack_public_path__ + "static/media/games-banner-bm.ec94d005.webp";